import { 
    TRANSLATED_LIST_REQUEST, 
    TRANSLATED_LIST_RECIEVE, 
    TRANSLATED_LIST_ERROR,
    SET_TRANSLATED_LIST,
    SET_LANGUAGE,
    SET_DEFAULT_LANGUAGE
} from "../action_types";

export const translatedListReducer = (state = {
    isFetching: false,
    list: {
        purposes: [],
        features: [],
    }
}, action) => {
    switch (action.type) {
        case TRANSLATED_LIST_REQUEST:
            return Object.assign({}, state, {
                isFetching: true,
            });

        case TRANSLATED_LIST_RECIEVE:
            return Object.assign({}, state, {
                isFetching: false,
            });

        case TRANSLATED_LIST_ERROR:
            return Object.assign({}, state, {
                list: action.list,
            });

        case SET_TRANSLATED_LIST:
            return Object.assign({}, state, {
                list: action.list,
            });
        
        default: 
            return state;
    }
};

export const setLanguageReducer = (language = 'en', action) => {
    switch(action.type){
        case SET_LANGUAGE:
            return action.language;

        case SET_DEFAULT_LANGUAGE:
            return 'en';

        default: return language;
    }
};